import { Modal, type TpModalProps } from '@mentalgrowth/ui-kit-web';
import { forwardRef, memo } from 'react';

const UiKitModal = memo(
  forwardRef<HTMLDivElement, TpModalProps>((props: TpModalProps, ref) => (
    <Modal {...props} ref={ref} />
  )),
);

UiKitModal.displayName = 'UiKitModal';

export default UiKitModal;
